import { IAppState } from '../../common/state';

export const getUserId = ({ user }: IAppState): number | undefined => {
  if (!user.isAuthenticated) {
    return undefined;
  }

  return user.userId;
};
